import React from 'react';
import { Button, Typography } from 'antd';
import NotfoundImage from '../assets/not_found.png'

const { Title, Paragraph } = Typography;

const NotFoundPage = () => {
  const handleReturnToHomepage = () => {
    window.location.href = '/';
  };

  return (
    <div className="bg-background-light not-found-container text-center pt-5">
      <div className="not-found-content text-center">
       
        <img
          src={NotfoundImage} 
          alt="Page Not Found"
          className="not-found-image"
        />

        {/* 404 Text */}
        <Title level={1} className="not-found-404">
          404
        </Title>

        {/* Oops! Page Not Found Heading */}
        <Title level={3} className="not-found-heading">
          Oops! Page Not Found
        </Title>

        {/* Explanatory Paragraph */}
        <Paragraph className="not-found-description">
          Sorry, the page you are looking for doesn't exist. It might have
          been moved, deleted, or you may have mistyped the URL.
        </Paragraph>

        {/* Return to Homepage Button */}
        <Button
          type="primary"
          size="large"
          className="not-found-button"
          onClick={handleReturnToHomepage}
        >
          Return to Homepage
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;